import { useEffect, useRef } from "react";
import classNames from "classnames";
import { Controller } from "react-hook-form";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/airbnb.css";
import "flatpickr/dist/l10n/it.js";
import "flatpickr/dist/l10n/fr.js";
import "flatpickr/dist/l10n/es.js";
import "flatpickr/dist/l10n/pt.js";
import Icon from "./icon";

const FlatpickrInput = ({
  control,
  type,
  name,
  feedback,
  required,
  disabled,
  toggleLabel,
  placeholder,
  locale = "en",
}) => {
  const ref = useRef();

  const FlatpickrOptions = {
    date: {
      dateFormat: "Z",
      altInput: true,
      altFormat: "d/m/Y",
      allowInput: false,
      wrap: true,
      locale,
      // disableMobile: true,
    },
    "date-string": {
      dateFormat: "Z",
      altInput: true,
      altFormat: "d/m/Y",
      allowInput: false,
      wrap: true,
      locale,
      // disableMobile: true,
    },
    time: {
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      allowInput: true,
      altInput: true,
      altFormat: "H:i",
      time_24hr: true,
      wrap: true,
      locale,
      // disableMobile: true,
    },
    datetime: {
      enableTime: true,
      dateFormat: "Z",
      altInput: true,
      altFormat: "d/m/Y H:i",
      allowInput: false,
      time_24hr: true,
      wrap: true,
      locale,
      // disableMobile: true,
    },
  };

  useEffect(() => {
    if (ref?.current?.flatpickr?.altInput) {
      if (ref.current.flatpickr.altInput) {
        ref.current.flatpickr.altInput.disabled = disabled;
        ref.current.flatpickr.altInput.readOnly = true;
      }
      if (ref.current.flatpickr.input) {
        ref.current.flatpickr.input.disabled = disabled;
        ref.current.flatpickr.input.readOnly = true;
      }
      if (ref.current.flatpickr.mobileInput) {
        ref.current.flatpickr.mobileInput.disabled = disabled;
      }
      // if (ref.current.flatpickr.calendarContainer) {
      //   ref.current.flatpickr.calendarContainer.role = "region";
      //   ref.current.flatpickr.calendarContainer.ariaLabel = "Calendar";
      // }
    }
  }, [disabled]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event?.key === "Backspace" &&
        ref?.current?.flatpickr?.altInput.className.includes("active")
      ) {
        ref.current.flatpickr.clear();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field: { onChange, onBlur, onOpen, ...others } }) => (
        <Flatpickr
          {...others}
          ref={ref}
          options={FlatpickrOptions[type]}
          onChange={(_dates, currentdateString) => {
            onChange(currentdateString);
          }}
          onOpen={() => (disabled ? 0 : onOpen)}
          onBlur={() => 0}
          onClose={onBlur}
        >
          <div className="flatpickr">
            <input
              type="text"
              name={name}
              id={name}
              data-input
              placeholder={placeholder}
              className={`form__input form__input--${type}`}
              disabled={disabled}
            />
            <button
              className={classNames("form__input-calendar", {
                "form__input-calendar--error": feedback === "error",
                "form__input-calendar--ok": feedback === "ok",
              })}
              data-toggle
              title={toggleLabel}
              aria-label={toggleLabel}
              type="button"
              disabled={disabled}
            >
              <Icon
                name={
                  ["date", "date-string"].includes(type)
                    ? "calendar"
                    : type === "time"
                    ? "clock"
                    : "calendar-clock"
                }
                className={
                  ["date", "date-string"].includes(type)
                    ? "calendar"
                    : type === "time"
                    ? "clock"
                    : "calendar-clock"
                }
              />
            </button>
          </div>
        </Flatpickr>
      )}
    />
  );
};

export default FlatpickrInput;
